import React from 'react';
import { price } from 'researcher/helpers/price';
import { T } from 'shared/helper/translate';
import Link from 'shared/components/Link';
import InvoiceTable from './InvoiceTable';
import Paginator from './Paginator';
var InvoiceHistory = function InvoiceHistory(_ref) {
  var allowsFapiaoProcessingAfterPayment = _ref.allowsFapiaoProcessingAfterPayment,
    currency = _ref.currency,
    displayingUnpaidInvoices = _ref.displayingUnpaidInvoices,
    filteredInvoices = _ref.filteredInvoices,
    onChangePage = _ref.onChangePage,
    onFapiaoCancelled = _ref.onFapiaoCancelled,
    pages = _ref.pages,
    paginatedInvoices = _ref.paginatedInvoices,
    pagination = _ref.pagination,
    selectedInvoiceNumbers = _ref.selectedInvoiceNumbers,
    unpaidInvoicetotal = _ref.unpaidInvoicetotal,
    updateSelections = _ref.updateSelections;
  var paymentLink = "/researcher/invoices/pay/".concat(selectedInvoiceNumbers.map(function (invoiceNumber) {
    return encodeURIComponent(invoiceNumber);
  }).join(','));
  return /*#__PURE__*/React.createElement("div", {
    className: "invoice-history"
  }, selectedInvoiceNumbers.length > 0 ? /*#__PURE__*/React.createElement("div", {
    className: "alert alert-info mt-4 mb-4"
  }, /*#__PURE__*/React.createElement("div", {
    className: "pull-right"
  }, /*#__PURE__*/React.createElement(Link, {
    className: "btn-link",
    to: paymentLink
  }, /*#__PURE__*/React.createElement(T, {
    source: "Pay now"
  }))), /*#__PURE__*/React.createElement(T.md, {
    inline: true,
    source: "Selected **%(number)s** invoice(s) totaling **%(price)s**",
    params: {
      number: selectedInvoiceNumbers.length,
      price: price(currency, unpaidInvoicetotal)
    }
  })) : null, /*#__PURE__*/React.createElement(InvoiceTable, {
    allInvoices: filteredInvoices,
    allowsFapiaoProcessingAfterPayment: allowsFapiaoProcessingAfterPayment,
    enableSelection: displayingUnpaidInvoices,
    invoices: paginatedInvoices,
    onFapiaoCancelled: onFapiaoCancelled,
    selectedInvoiceNumbers: selectedInvoiceNumbers,
    updateSelections: updateSelections
  }), /*#__PURE__*/React.createElement(Paginator, {
    invoices: filteredInvoices,
    pages: pages,
    pagination: pagination,
    onChangePage: onChangePage
  }));
};
export default InvoiceHistory;